/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkip2ForwardIcon16Solid = forwardRef('MediaUiASkip2ForwardIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M16 3.5a1 1 0 1 0-2 0v3.056L9.061 2.989C8.201 2.368 7 2.982 7 4.042v2.514L2.061 2.989C1.201 2.368 0 2.982 0 4.042v7.915c0 1.061 1.201 1.675 2.061 1.054L7 9.444v2.513c0 1.061 1.201 1.675 2.061 1.054L14 9.444V12.5a1 1 0 1 0 2 0v-9Z" })));
});
